import { hasQueryParam } from './url-helpers'

const debugLog = <A extends Array<unknown>>(...args: A): void => {
  if (hasQueryParam('debug')) {
    console.log.apply(null, args)
  }
}

export default debugLog
